import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useForm } from 'react-hook-form'
import fileDownload from 'js-file-download';
import { Oval } from 'react-loader-spinner'
import Cookies from 'universal-cookie'
import dayjs from 'dayjs';
import clsx from 'clsx'
import { Button, ContentsLayout, ContentsHeader, Radio } from 'src/components'
import styles from './Import.module.scss';

/**
 * Import コンポーネント
 * 鳥獣害データのインポート
 * @returns React.ReactNode
 */
const Import: React.FC = () => {

  /**
   * GoogleAnalytics用トラッキング
   */
  useEffect(() => {
    window.gtag !== undefined && window.gtag('config', `${process.env.REACT_APP_DEV_TRACKING_ID}`, { page_path: window.location.pathname });
  }, []);

  /**
   * CSV取込フォーム
   */
  const { register, watch, handleSubmit, formState: { errors } } = useForm();

  /**
   * ログイン情報のCookie
   */
  const [cookie] = useCookies()

  /**
   * ログイン情報削除時に使用
   */
  const cookies = new Cookies();

  //CSV取込結果表示時の日付格納
  const [successDate, setSuccessDate] = useState('');

  /**
   * CSVDownloadマウント時動作処理用（CSVDownloadはマウント時に実行されるため）
   */
  // const [isDownloaded, setIsDownloaded] = useState(false);

  /**
   * 空CSVダウンロード
   */
  // function handleCSVDownload() {
  //   setIsDownloaded(true)
  // }

  /**
* API通信中判定フラグ
*/
  const [loading, setLoading] = useState(false);

  /**
   * CSV取込時の処理
   * @param data
   */
  async function onSubmit(data: any) {
    setLoading(true);
    const success = dayjs().format('YYYYMMDD_hhmmss')
    //ファイルはそのまま渡すとエラーになるのでフォームデータに変更する
    const formData = new FormData();
    formData.append('csv', data.file[0], data.file[0].name);
    formData.append(`${watch('category')}[]`, '')
    axios.post(`${process.env.REACT_APP_DEV_API_URL}/csv/import`,
      formData, {
      headers: {
        'Authorization': `Bearer ${cookie.verminData.api_token}`,
        'content-type': 'multipart/form-data',
      }
    }).then(async (data: any) => {
      setLoading(false);
      setSuccessDate(success);
      // success時の処理
      if (data?.data?.status === "データの登録は正常に行われました。") {
        setIsSuccessPopup(true);
        setTimeout(() => {
          setIsSuccessPopup(false);
        }, 3000);
        //フォーマットを整える
        const tmp = await watch('file')[0].text();
        const csvList = await tmp.split('\r\n').map((row: string) => row.split(','));
        await csvList.map((value: any, index: number) => value.unshift(index + 1));
        const outputFile = await csvList.filter((value: any) => value[2] && !isNaN(value[1])).map((value: any, index: number) => `"${value[0]}行目", "${(watch('category') === 'camera' || watch('category') === 'user') ? data?.data?.data[index]?.name2 : data?.data?.data[index]?.name1}", "ID:${data?.data?.data[index]?.No}"\n`).join('');
        fileDownload(outputFile, `登録処理結果_成功${success}.txt`);
      }
      //error時の処理
    }).catch(async (err) => {
      setLoading(false);
      setIsErrorPopup(true);
      setTimeout(() => {
        setIsErrorPopup(false);
      }, 3000);
      const errorTxt = err?.response?.data?.errors?.map((error: any) => {
        return `"${error.line}行目", "${error.message}"\n`
      })
      fileDownload(errorTxt.join(''), `登録処理結果_失敗${success}.txt`);
      //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
      if (err?.response?.data?.message === "Unauthenticated.") {
        await cookies.remove('verminData');
        await window.location.replace('/');
      }
    })
  }

  /**
   * CSV取込時のポップアップ出現フラグ
   */
  const [isErrorPopup, setIsErrorPopup] = useState(false);
  const [isSuccessPopup, setIsSuccessPopup] = useState(false);

  return (
    <ContentsLayout>
      <ContentsHeader title="データ取り込み">
        {/* <Button disabled={isDownloaded} onClick={handleCSVDownload}>空CSVダウンロード</Button> */}
      </ContentsHeader>
      <div className={clsx(styles.popup, isSuccessPopup && styles.success)}>登録に成功しました。登録情報のIDはダウンロードされます、登録処理結果_成功_{successDate}.txtでご確認ください
      </div>
      <div className={clsx(styles.popup, isErrorPopup && styles.error)}>登録に失敗しました。失敗の原因はダウンロードされます、登録処理結果_失敗_{successDate}.txtでご確認ください
      </div>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <p className={styles.fieldTitle}>データ種別</p>
        <div className={styles.rowField}>
          <Radio
            value="vermin"
            {...register('category')}
            defaultChecked={true}
            className={styles.radioText}
          >
            害獣
          </Radio>
          <Radio
            value="trap"
            {...register('category')}
            className={styles.radioText}
          >
            罠
          </Radio>
          <Radio
            value="prev_faci"
            {...register('category')}
            className={styles.radioText}

          >
            防止施設
          </Radio>
          <Radio
            value="camera"
            {...register('category')}
            className={styles.radioText}

          >
            カメラ
          </Radio>
          <Radio
            value="damage"
            {...register('category')}
            className={styles.radioText}
          >
            被害
          </Radio>
          <Radio
            value="mesh"
            {...register('category')}
            className={styles.radioText}
          >
            メッシュ
          </Radio>
          <Radio
            value="user"
            {...register('category')}
            className={styles.radioText}
          >
            ユーザー
          </Radio>
        </div>
        <label className={styles.fileWrapper}>
          {errors?.file?.type === "required" ? "ファイルを選択" : (watch("file") ? watch("file")[0]?.name : "ファイルを選択")}
          <input multiple type="file"
            accept='.csv'
            className={styles.file}
            {...register('file', { required: true, validate: value => value.length !== 0 && ((value[0]?.text()?.then(() => true).catch(() => false)) || (value[0].name.split('.').pop() === '.csv')) })}
          />
        </label>
        <Button type="submit">
          取込
        </Button>
        {/* {isDownloaded && <CSVDownload data={[]} />} */}
        {errors?.file?.type === "required" &&
          <p className={styles.duplicateErrorText}>ファイルを選択してください。</p>
        }
        {errors?.file?.type === "validate" &&
          <p className={styles.duplicateErrorText}>ファイルが存在しません。</p>
        }
      </form>
      {loading &&
        <div className={styles.modalWrapper}>
          <div className={styles.modalOverlay}>
            <Oval
              ariaLabel="loading-indicator"
              height={75}
              width={75}
              strokeWidthSecondary={1}
              color="#3a6468"
              secondaryColor="white"
            />
          </div>
        </div>
      }
    </ContentsLayout >
  );
};

export default Import;

